/**
 * Verifica portas USB já concedidas ao site (Web Serial API).
 * @returns {Promise<number>} quantidade de portas concedidas (0 se indisponível).
 */
export const getGrantedUsbPortCount = () => {
    if (typeof navigator === 'undefined' ||
        !navigator.serial ||
        typeof navigator.serial.getPorts !== 'function') {
        return Promise.resolve(0);
    }
    return navigator.serial.getPorts()
        .then(ports => ports.length)
        .catch(() => 0);
};
